import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { BindingContext } from '../../../../shared/models/BindingContext';
import {
	BoardedMerchantCounts,
	IBoardedMerchantCounts
} from '../../../../shared/models/EvoSalesPortalModel';
import { DashboardService } from '../../../../shared/services/dashboard.service';
import { Constants } from '../../../../shared/classes/constants';
import { Router } from '@angular/router';
import { UserAccessService } from 'app/shared/services/user-access.service';

@Component({
	selector: 'app-boarded-merchant-counts-chart',
	templateUrl: './boarded-merchant-counts-chart.component.html',
	styleUrls: ['./boarded-merchant-counts-chart.component.scss']
})
export class BoardedMerchantCountsChartComponent implements OnInit {
	@Input() bindingContext: BindingContext;
	private dashboardError: string = "Error loading dashboard item, please contact support."
	//#region Fields
	datasets = new Array<any>();
	labels = new Array<string>();
	data = new Array<number>();
	legend = false;
	chartType = 'pie';
	public internalMessage: string;
	public errorMessage: string;
	_currentTabName: string;
	public permitClick: boolean = false;
	_rawData: BoardedMerchantCounts;

	options = {
		responsive: true
	};

	chartColors: any[] = [
		{
			backgroundColor: this.getColors()
		}
	];
	//#endregion

	//#region Properties
	get rawData(): BoardedMerchantCounts {
		return this._rawData;
	}

	set rawData(input: BoardedMerchantCounts) {
		this._rawData = input;
	}

	get currentTabName(): string {
		return this._currentTabName;
	}

	@Input()
	set currentTabName(input: string) {
		this._currentTabName = input;
		let months: number = Constants.ReportingTimePeriodEnum.Monthly;
		if ('Y' === input) {
			months = Constants.ReportingTimePeriodEnum.Yearly;
		}
		this.getDashboardData(months);
	}

	//#endregion

	//#region Construction
	constructor(private dashboardSvc: DashboardService,
		private router: Router,
		private accessSvc:UserAccessService) {
			this.SetClickThrough();
	}

	ngOnInit() { 

	}
	//#endregion

	getColors(): Array<string> {
		const result = new Array<string>();
		for (let i = 0; i < 2; i++) {
			result.push(
				'#945DA6',
				'#BC692E',
				'#F6A335',
				'#B42991',
				'#75A842',
				'#AEE1FA'
			);
		}
		return result;
	}
	SetClickThrough() {
		//console.log("Setting pie chart click");
		this.accessSvc.GetAccessLevelBySecurableName('|OPEN-NOT-PROCESSING', 'REPORTS', null, null, false).then(resp => {
			//console.log("pie click resp:", resp);
			if (resp > 0) {
				//console.log("Access to pie granted");
				//They have at least read access
				this.permitClick = true;
			}
		});
	}

	onChartClick(event: any) {
		if (this.permitClick) {
			//console.log("pie chart click", event);
			this.router.navigate(['/reports/open-np']);
		}
	}
	populateDataSet() {
		this.datasets = new Array<any>(); // ngb charts uses an array.
		const data = new Array<number>();
		this.labels = new Array<string>();

		const item: BoardedMerchantCounts = this.rawData;

		data.push(item.OpenNotProcessing);
		data.push(item.OpenProcessing);
		data.push(item.Closed);
		this.labels.push('Open: Not Processing');
		this.labels.push('Open: Processing');
		this.labels.push('Closed');

		const ds = { label: 'Boarded Merchant Counts', data: data };
		this.datasets.push(ds);
	}

	getDashboardData(months: number) {
		this.bindingContext.beginGet();
		this.errorMessage = undefined;
		this.internalMessage = undefined;
		this.dashboardSvc.getBoardedMerchantCounts(months).subscribe(
			(resp: Array<IBoardedMerchantCounts>) => {
				const bmcObj = resp[0];
				this.rawData = new BoardedMerchantCounts(bmcObj);
				if (undefined !== resp && this.rawData.Total > 0) {
					this.populateDataSet();
					this.bindingContext.endGet(true);
				} else {
					this.internalMessage = 'No results to display.'
					this.bindingContext.endGet();
				}

			},
			(response: HttpErrorResponse) => {
				this.bindingContext.endGet();
				//this.errorMessage = this.dashboardError;
				this.bindingContext.showAlert(BindingContext.alertType.danger, this.dashboardError, true);
			}
		);
	}
}
